/**
 * A collection of helper classes to make it easier to deal with vanilla JS and possible exceptions for non existing elements
 */
export default class i96Toolbox {

    static debug = false;

    // HELPER
    // -----------------------------------
    /**
     * Converts a number (float) to a string with two decimal points
     * @param str
     * @param force_conversion if true and the str is not really a string but a number, then the str will be converted to a string. if false the str is returned as is
     * @returns {*|string}
     */
    static numberToString(str, force_conversion) {
        if (this.debug) console.log('numberToString: ', str, typeof str);

        if ( (typeof str == 'string') && (str == '-')) {
            return str;
        }

        if (typeof str !== 'number') {
            if (!force_conversion) {
                return str;
            }
            str = this.parseNumber( str );
        }

        const res = this.parseNumber( str ).toFixed(2).replace('.', ',');// + '*<sup>a</sup>';

        // console.log('NUMBER -------------------->', this.parseNumber( str ).toFixed(2), res);

        return res;
    }
    parsePrice(str, force_conversion = false) {
        return this.numberToString( str, force_conversion ) + '&euro;';
    }
    parseNumber(num, force_conversion = false) {
        //if (this.debug) console.log('parseNumber: ', str, typeof str);
        if (typeof num !== 'string') {
            if (!force_conversion) {
                return num;
            }
            num = this.parseNumber( num );
        }
        return parseFloat( num.replace(',', '.') );
    }

    round( val, pow = 2) {
        return Math.round( val * Math.pow(10, pow)) / Math.pow( 10, pow);
    }


    formatNumber( num ) {
        const izPrice = typeof num == 'string' && (num.indexOf('&euro;') >= 0);

        if (izPrice) {
            return this.parsePrice( num.replace('&euro;', ''), true);
        }

        return this.numberToString( num, true );
    }

    /**
     * Helper method to output debug info and return the correct bool value if element has not been found
     *
     * @param selector
     * @param dowhat 'addClass' | 'removeClass' | 'setInnerHtml'
     * @param info
     * @param debug
     * @returns {boolean}
     */
    modifyElement( selector, dowhat, info, debug ) {

        if ( typeof selector !== 'string' || !selector) {
            console.error('i96Toolbox > modifyElement (',selector, dowhat, info, debug, '): selector is empty');
            return false;
        }

        const ele = document.querySelectorAll( selector );
        if (ele.length) {

            switch (dowhat) {
                case 'addClass':
                    ele.forEach( e => e.classList.add( info ) );
                    // ele.classList.add( info );
                    break;
                case 'removeClass':
                    ele.forEach( e => e.classList.remove( info ) );
                    // ele.classList.remove( info );
                    break;
                case 'setInnerHtml':
                    ele.forEach( e => e.innerHTML = info );
                    // ele.innerHTML = info;
                    break;
            }

            if (debug !== false) console.log('i96Toolbox > modifyElement (' + selector + ', ' + dowhat + ', ' + info + ') : ');
            return true;
        }
        if (debug !== false) console.error('i96Toolbox > modifyElement (' + selector + ', ' + dowhat + ', ' + info + ') : does not match an element.');
        return false;
    }

    /**
     * Adds a class to the single element which the selector matches
     *
     * @param selector
     * @param classname
     * @returns {boolean} true if selector matches an element, false if not
     */
    addClass( selector, classname, debug = false ) {
        return this.modifyElement( selector, 'addClass', classname, debug ? 'added...' : false)
    }

    /**
     * Removez a class to the single element which the selector matches
     *
     * @param selector
     * @param classname
     * @returns {boolean} true if selector matches an element, false if not
     */
    removeClass( selector, classname, debug = false ) {
        return this.modifyElement( selector, 'removeClass', classname, debug ? 'removed...' : false)
    }

    /**
     * Checks if an element exists and the selector ist correct
     *
     * @param selector
     * @returns {boolean}
     */
    exists( selector ) {
        if ( typeof selector !== 'string' || !selector) {
            console.error('i96Toolbox > exists ('+selector+'): selector is empty');
            return false;
        }

        const ele = document.querySelector( selector );
        if (ele) {
            return true;
        }
        return false;
    }

    hasClass( selector, classname, debug = false ) {
        const ele = document.querySelector( selector );
        if (ele) {
            return ele.classList.contains( classname );
        }
        return false;
    }



    /**
     * Helper function that checks the existence of the selected element before setting the innerHTML to prevent errors
     *
     * @param selector
     * @param html
     */
    setInnerHtml(selector, html, debug = true) {
        return this.modifyElement( selector, 'setInnerHtml', html, debug ? 'set...' : false)
    }


    static findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substring(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }

    /**
     * Remove all special characters, replace diacritics with corresponding ASCII
     * @param text
     * @returns {*}
     */
    static sluggify( text ) {
        return text
            .replace(/[ÀÁÂÃÄÅ]/g,"A")
            .replace(/[àáâãäå]/g,"a")

            .replace(/[ÈÉÊË]/g,"E")
            .replace(/[éèêë]/g,"e")

            .replace(/[ÍÌÎÏ]/g,"I")
            .replace(/[íìîï]/g,"i")

            .replace(/[Ñ]/g,"N")
            .replace(/[ñ]/g,"n")

            .replace(/[ÓÒÔÖÕØŒ]/g,"O")
            .replace(/[óòôöõøœ]/g,"o")

            .replace(/[ÚÙÛÜ]/g,"U")
            .replace(/[úùûü]/g,"u")

            .replace(/[ç]/g,"c")
            .replace(/[Ç]/g,"c")

            .replace(/[ß]/g,"s")

            .replace(/[ ]/g,"_")

            .replace(/[^a-z0-9_]/gi,''); // final clean up
    }

}
